
import axios from 'axios';

// prod
 let base = 'https://admin.fmc.com.ua/api/v1';

// dev
// let base = 'https://fmc.zula.pro/api/v1';

export default {
    collection: {
        get(slug) {
            return axios.get(base+'/' + slug + '/');
        }
    },
    culture: {
        get(id) {
            return axios.get(base+'/cultures/' + id);
        }
    },
    settings: {
        get() {
            return axios.get(base+'/settings/');
        }
    },
    search(q) {
        return axios.get(base + '/products/?search=' + q);
    },
    crop() {
        return axios.get(base + '/crop-protection-systems/');
    }
   
};
